import React from "react";
import Style from '../../styles/landing/Suporte.module.css'; 
import { FaArrowLeft } from "react-icons/fa";

export default function ArtAvaliacaoCorporal({ title }) {

  return (
    <div className={Style.containerArt}>
      <div className={Style.articleHeader}>
        <h2>{title}</h2>
      </div>
      <div className={Style.articleBody}>
        <p>
          A avaliação corporal da LesVita é feita a partir de fotos tiradas pelo
          próprio celular, seguindo um passo a passo guiado.
        </p>
        <ol>
          <li>Acesse o app e entre na área <strong>“Avaliação corporal”</strong>.</li>
          <li>Siga as instruções de posicionamento e vestimenta.</li>
          <li>Faça as fotos frontal e lateral conforme o guia.</li>
          <li>Confirme as imagens e envie para análise.</li>
        </ol>
        <p>
          Depois do envio, nossa IA processa as imagens e devolve sua composição
          corporal diretamente no app, normalmente em poucos minutos.
        </p>
      </div>
    </div>
  );
}